module.exports = __webpack_public_path__ + "img/pr-1.25605a75.png";